/**
 * @fileoverview Орбита зоны ожидания (holding pattern над полем).
 */

import type { Plane, Point } from "../state/types";

/** Центр зоны ожидания */
const ORBIT_CX = 800;
const ORBIT_CY = 100;

/**
 * Позиция на эллиптической орбите ожидания.
 * @param p — борт (используется `orbit` угол)
 * @param idx — слот (1…), сжимает эллипс для дальних слотов
 */
export function orbitPos(
  p: Plane,
  idx: number,
): Point & { rx: number; ry: number } {
  const slot = Math.min(idx, 4);
  const rx = 400 - slot * 55;
  const ry = 46 - slot * 5;
  return {
    x: ORBIT_CX + Math.cos(p.orbit) * rx,
    y: ORBIT_CY + Math.sin(p.orbit) * ry,
    rx,
    ry,
  };
}
